import { axiosApi } from '../globals';
import { Json } from '../types';

export namespace projects {
  export const getAll = () => {
    const res = axiosApi.run('get', '/v2/projects');
    return res;
  };

  export const get = async (id: string) => {
    const res = await axiosApi.run('get', `/v2/projects/${id}`);

    const isSuccess = res.data;

    return Promise.resolve({
      isSuccess,
      data: res.data,
    });
  };

  export const create = (data: any) => {
    const res = axiosApi.run('post', '/v2/projects', data);
    return res;
  };

  export const patch = (id: string, data: any) => {
    const res = axiosApi.run('patch', `/v2/projects/${id}`, data);
    return res;
  };

  export const remove = (id: string) => {
    const res = axiosApi.run('delete', `/v2/projects/${id}`);
    return res;
  };

  export const addModel = (projectId: string, model: Json) => {
    const res = axiosApi.run('post', `/v2/projects/${projectId}/models`, model);
    return res;
  };

  export const removeModel = (projectId: string, modelId: string) => {
    const res = axiosApi.run('delete', `/v2/projects/${projectId}/models/${modelId}`);
    return res;
  };

  export const patchModel = (projectId: string, modelId: string, data: Json) => {
    const res = axiosApi.run('patch', `/v2/projects/${projectId}/models/${modelId}`, data);
    return res;
  };

  export const patchModelValues = (projectId: string, modelId: string, values: Json) => {
    const res = axiosApi.run(
      'patch',
      `/v2/projects/${projectId}/models/${modelId}/valuesModel`,
      values
    );
    return res;
  };

  export const setModels = (projectId: string, models: Json) => {
    const res = axiosApi.run('put', `/v2/projects/${projectId}/models`, models);
    return res;
  };

  export const clear = (projectId: string) => {
    setModels(projectId, []);
  };
}
